var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRemove(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 15.2727V8.72727C26 8.43182 25.8928 8.17614 25.6784 7.96023C25.464 7.74432 25.2101 7.63636 24.9167 7.63636H13V1.09091C13 0.772726 12.8984 0.511362 12.6953 0.306818C12.4922 0.102272 12.2326 0 11.9167 0C11.6458 0 11.375 0.113636 11.1042 0.340908L0.304688 11.2159C0.101562 11.4205 0 11.6818 0 12C0 12.3182 0.101562 12.5795 0.304688 12.7841L11.138 23.6932C11.3411 23.8977 11.6007 24 11.9167 24C12.2101 24 12.464 23.892 12.6784 23.6761C12.8928 23.4602 13 23.2045 13 22.9091V16.3636H24.9167C25.2101 16.3636 25.464 16.2557 25.6784 16.0398C25.8928 15.8239 26 15.5682 26 15.2727Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove);
export default __webpack_public_path__ + "static/media/remove.c5c7d801e1191cd09889df31f884054a.svg";
export { ForwardRef as ReactComponent };